<template>
  <v-container v-html="text"> </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "DataProtection",
  data: () => ({
    text: "",
  }),
  methods: {
    async fetchDataProtection() {
      let response = await axios.get("/data-protection.html");
      this.text = response.data;
    },
  },
  async created() {
    await this.fetchDataProtection();
  },
};
</script>
